<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
                <a-form-item label="type" name="type">
                    <a-input v-model:value="form.type"/>
                </a-form-item>
            </div>
            <a-row :gutter="20">
                <a-col :span=24>
                    <a-form-item label="名称" name="naturalName">
                        <a-input v-model:value="form.naturalName" placeholder="请输入名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="图片" name="naturalNatural">
                        <img-upload v-model:value="form.naturalNatural"/>
                    </a-form-item>
                </a-col>

                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
// import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {honor} from "@/api/companyService";
import ImgUpload from "@/components/form/upload/ImgUpload";

export default {
    name: "AddOrEditModal",
    components: {ImgUpload},

    mixins: [formMixin],
    data() {
        return {
            form: {
                id: null,
                type: null,
                naturalName: null,
                naturalNatural: null,

            },
            rules: {
               id:[],
                type:[],
                naturalName:[],
                naturalNatural:[],
            },
            submitUrl: honor.saveOrUpdate
        }
    },
    created() {
    },
    methods: {

    },
}
</script>
<style scoped lang="less">
</style>
